export const getListItemHeight = (props) => {

  const {isMobile, selectionWindowView, itemsList} = props;

  // console.log("itemsList", itemsList);

  if (isMobile || !itemsList || !itemsList.current) {
    return 0
  }
  let widthPercentage = 32.3;
  switch(selectionWindowView) {
    case 1:
      widthPercentage = 32.3;
      break;
    case 2:
      widthPercentage = 24;
      break;
    case 3:
      widthPercentage = 19;
      break;
    default:
      break;
  }
  return Math.round(itemsList.current.clientWidth*widthPercentage/100);

};

export const shouldReplaceSelectionInfoFeature = (selectedFeature) => {
  if ((document.kvConfig.visualizerType === "bvScene" || document.kvConfig.visualizerType === "bvLook")
    && selectedFeature.getParent) {
    const featureG = selectedFeature.getParent();
    if (featureG && featureG.oneLayerPosition && featureG.activeFeature
      && (featureG.activeFeature.dbFeature.id !== selectedFeature.dbFeature.id)
      && featureG.activeFeature.getMatchingFeatureName && selectedFeature.getMatchingFeatureName
      && (featureG.activeFeature.getMatchingFeatureName() === selectedFeature.getMatchingFeatureName())) {
      selectedFeature = featureG.activeFeature; // we changed left change to right in nav position modal
    }
  }
  return selectedFeature
}
